import React from "react";

export default function CloseButton() {
    return <svg data-name="close-btn">
        <path className="close-btn-17" d="M0,5.51,22.51,87.63a1,1,0,0,0,1.26.66L95.29,66.06a1,1,0,0,0,.7-1.13L86.48.83a1,1,0,0,0-1-.83L1,4.21A1,1,0,0,0,0,5.51Z"/>
        <path className="close-btn-18" d="M74.59,54.63,63.9,43.92,74.59,33.21A8.4,8.4,0,1,0,62.71,21.33L52,32,41.3,21.33A8.4,8.4,0,1,0,29.43,33.22L40.14,43.93,29.43,54.63A8.4,8.4,0,1,0,41.31,66.5L52,55.79,62.72,66.5A8.39,8.39,0,1,0,74.59,54.63Z"/>
        <path className="close-btn-2" d="M73.9,45.57,63.21,34.86,73.9,24.15A8.4,8.4,0,1,0,62,12.28L51.32,23,40.61,12.28A8.4,8.4,0,1,0,28.74,24.16L39.45,34.87,28.74,45.57A8.4,8.4,0,0,0,40.62,57.45L51.33,46.74,62,57.45A8.4,8.4,0,1,0,73.9,45.57Z"/>
    </svg>;
}
